<template>
  <div class="uk-grid uk-grid-small uk-child-width-1-2@m" data-uk-grid>
    <div>
      <v-select :options="makes" v-bind="$attrs" v-on="$listeners" name="makes" v-model="selected.make"
        :reduce="make => make.value" placeholder="Hersteller wählen">
        <template #no-options>
          Kein(e) Hersteller gefunden.
        </template>
      </v-select>
      <span v-if="formErrors && formErrors['make']" class="uk-text-small uk-text-danger">{{ formErrors['make'] }}</span>
    </div>
    <div>
      <v-select :options="availableModels" v-bind="$attrs" v-on="$listeners" name="model"
        :reduce="model => model.value" placeholder="Modell wählen" v-model="selected.model" @input="onChange()">
        <span slot="no-options">Bitte Hersteller wählen</span>
        <template v-slot:option="option">
          <span v-if="option.id && option.group" style="margin-left: 10px;">{{ option.label }}</span>
          <span v-else>{{ option.label }}</span>
        </template>
      </v-select>
      <span v-if="formErrors && formErrors['model']" class="uk-text-small uk-text-danger">{{ formErrors['model'] }}</span>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { find } from 'lodash'
export default {
  inheritAttrs: false,
  props: {
    selected: {
      required: true,
      type: Object
    },
    makes: {
      required: true
    },
    layout: {
      required: false,
      type: String,
      default: 'stacked'
    },
    formErrors: {
      required: false
    }
  },
  components: {
    vSelect
  },
  watch: {
    "selected.make": function (val, oldVal) {

      if (typeof oldVal !== "undefined" && oldVal !== null && val !== oldVal) {
        this.selected.model = null;
      }

      this.onChange();
    }
  },
  computed: {
    availableModels() {
      const selectedMakeObj = find(this.makes, m => {
        return m.value === this.selected.make;
      });

      return selectedMakeObj ? selectedMakeObj.models : [];
    },
  },
  methods: {
    onChange() {
      this.$emit("change", this.selected);
    },
  }
};
</script>
